<template>
    <div>

        <TextBanner>
        Vom Mond zum Mars kostet es deutlich weniger Energie als von der Erde aus, da der Mond keine Atmosphäre hat, die überwunden werden muss.  
        </TextBanner>

        <InfoBox modalName="IB_Zeitplan">
            <template #title>Der Zeitplan</template>
            <template #subline></template>
            <template>
                <p>Die Artemis-Mission ist in viele Untermissionen eingeteilt. Zunächst wird die orbitale Raumstation aufgebaut und parallel dazu die Mondoberfläche mit Hilfe eines Fahrzeugs erforscht. </p><p></p>

                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/060_Erde_Mond.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            required (ratio): data-width, data-height
                            <img class="img-fluid" data-width="600" data-height="381" v-lazy="require('../assets/img/060_Erde_Mond_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa</div>
                        <!--Der Weg zum Mars ist weit. In zwei Etappen wollen verschiedene Raumfahrtagenturen dieses Ziel erreichen.-->                    
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>Wenn der erste Teil der Mission geschafft ist, rückt das nächste Ziel - der Mars - für die bemannte Raumfahrt in greifbare Nähe.</p>


                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/060_Mond_Mars.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="381" v-lazy="require('../assets/img/060_Mond_Mars_thb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Nasa</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>



            </template>
        </InfoBox>


        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot" v-on:click="infobox('TolleInfoBox')"></div>
        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                betaLimits: [.2, 3.14],
                radiusLimits: [10,150],
                position: [-1.2,1.1,80],   //[-1.2,1.1,80], target:[-5,0,0],   gerade:position: [-1.56,.9,80],target:[-5,0,0],
                target:[-5,0,0],
                animationSpeed: 1,
                useAutoRotationBehavior: true,
                idleRotationSpeed: 0.003,  //0.01
            },
            
            artemis_geo: {

                Station_All:{
                    visible: false,
                },
                //scaling: [1,1,-1],


                Pfeil_1:{
                    fade: false,
                    visible: true,
                    pickable: false
                },

                Pfeil_2:{
                    fade: false,
                    visible: true,
                    pickable: false
                },

                Erde:{
                    position: [0,0,900],   //200,0,2000],
                    visible: true,
                    pickable: false,
                },

                Mond:{
                    position:[-130,250,0],
                    scaling:[0.5,0.5,0.5],
                    pickable: false,

                },

                Mars:{
                    position: [0,180,-1300],
                    visible: true,
                    pickable: false,

                },

                Sonne:{
                    visible: true,
                    renderingGroupId:0,
                },

                Schatten_Mars: {
                    position: [0,180,-1300],
                    fade: true,
                    visible: true,
                    pickable: false,

                    },
                Schatten_Mond: {
                    fade: true,
                    visible: true,
                    pickable: false,

                    },
                Schatten_Erde: {
                    position:[0,0,900],
                    fade: true,
                    visible: true,
                    pickable: false,

                    },

                Weltall:{
                    fade: true,
                    visible: false,
                    },

                Label_bisMars:{
                    renderingGroupId:1,
                    billboardMode:7,
                    pickable: false,
                    visible: true,
                    text_km_mars:{
                        renderingGroupId:1,
                        }
                    },

                Label_bisMond:{
                    renderingGroupId:1,
                    billboardMode:7,
                    pickable: false,
                    visible: true,
                        text_km_mond:{
                            renderingGroupId:1,
                        }
                    },
            },

            hotspots: {
                info_11: {
                    visible: true,
                    renderingGroupId:1,
                    infoBox: 'IB_Zeitplan',
                    position: [0, 5, 0],
                    scale: 8,
                }
            },
           
        },
        babylonReady: function () {

        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
